import React from "react";
import { useReactToPrint } from "react-to-print";
import downloadIcon from "../../images/icons/download.svg";
export const DataDownloader = ({ downloadLink, printContentRef, }) => {
    function getDownloadFileName(downloadLink) {
        return downloadLink.split("/").pop();
    }
    const handlePrint = useReactToPrint({
        content: () => printContentRef.current,
        onBeforeGetContent: () => {
            const canvas = document.querySelector("canvas");
            const printImg = document.querySelector("img#printImg");
            if (printImg && canvas) {
                printImg.src = canvas.toDataURL();
            }
        },
    });
    let icon = downloadIcon;
    return (React.createElement("div", { className: "mt-5 mb-2 row" },
        React.createElement("div", { className: "ms-auto col-auto" },
            React.createElement("button", { className: "btn btn-primary", onClick: handlePrint },
                React.createElement("img", { src: icon, alt: "Pobieranie", className: "me-2" }),
                "Pobierz wy\u015Bwietlone dane")),
        React.createElement("a", { href: downloadLink, download: getDownloadFileName(downloadLink), className: "text-decoration-none col-auto" },
            React.createElement("button", { className: "btn btn-primary" },
                React.createElement("img", { src: downloadIcon, alt: "Pobieranie", className: "me-2" }),
                "Pobierz wszystkie dane"))));
};
